const FILE_TYPES = Object.freeze([
  'NVGreenlight General',
  'NVGreenlight Bot-Z Height',
  'NVGreenlight Top-Z Height',
  'NVGreenlight RDT',
])

export {
  FILE_TYPES
}
